import { actionCopyDa } from "./actionCopy";

export const ratingsListCopyDa = {
    addActivityPlaceholder: (current: number, max: number) => `Tilføj aktivitet ${current}/${max}`,
    add: actionCopyDa.add,
    emptyHint: "Tilføj aktiviteter ovenfor for at begynde at vurdere din sværhedsgrad",
    noDifficulty: "Ingen sværhedsgrad",
    unableToDo: "Kan ikke udføre",
    loading: "Indlæser aktiviteter...",
    loadError: "Kunne ikke indlæse din aktivitetsliste. Prøv igen.",
    noBaselineActivities:
        "Der blev ikke fundet baseline-aktiviteter for denne tracker. Fuldfør den første indtastning, før du indsender en opfølgning.",
    followUpHint: "Vurder din aktuelle sværhedsgrad for hver aktivitet, du valgte ved baseline.",
};
